import { render, staticRenderFns } from "./CenterViewShipping_Ap.vue?vue&type=template&id=882ca99c&scoped=true"
import script from "./CenterViewShipping_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewShipping_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewShipping_Ap.vue?vue&type=style&index=0&id=882ca99c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882ca99c",
  null
  
)

export default component.exports